import { Button } from "components/DesignSystem/Button/Button";
import { Chat } from "components/icons/LeftNav/Chat";
import { useChannelMessageCount } from "hooks/useChannelMessageCount";
import { HTMLAttributes, useEffect, useState } from "react";
import { useChatContext } from "stream-chat-react";

export type FilterType = {
  START_DATE: string;
  END_DATE: string;
  SELECT_PERIOD: string;
  FORMATION_TYPE: string[];
  STATE_REGISTRATIONS: string[];
  FILING_INFO: string[];
};

export type CustomChatSliderProps = {
  defaultChannelId: string;
  defaultUnreadCount: number;
  openTaskChat: (id: string) => void;
  taskId: string;
};

export const CustomChatSlider = ({
  defaultChannelId,
  defaultUnreadCount,
  openTaskChat,
  taskId,
}: CustomChatSliderProps) => {
  const [unreadCount, setUnreadCount] = useState<number>(defaultUnreadCount);
  const { client } = useChatContext();

  useEffect(() => {
    try {
      const channel = client.channel("messaging", defaultChannelId);
      const readSub = channel.on("message.read", (event) => {
        setUnreadCount(channel.countUnread());
      });

      const newSub = channel.on("message.new", (event) => {
        setUnreadCount(channel.countUnread());
      });

      return () => {
        readSub.unsubscribe();
        newSub.unsubscribe();
      };
    } catch (error) {}
  }, [defaultChannelId]);

  const onClick: HTMLAttributes<HTMLButtonElement>["onClick"] = (e) => {
    e.stopPropagation();
    openTaskChat(taskId);
  };

  return (
    <div>
      <Button customType="ghost_icon" size="xsmall" onClick={onClick}>
        <div className="t-flex t-items-center t-justify-center">
          {Boolean(unreadCount) && unreadCount > 0 && (
            <span className="t-border-solid t-border t-border-surface t-absolute t-right-1 t-top-1 t-h-4 t-w-4 t-rounded-full t-z-10 t-overflow-hidden">
              <span className="t-bg-red-50 t-text-caption t-h-4 t-w-4 t-text-white t-flex t-items-center t-justify-center">
                {unreadCount}
              </span>
            </span>
          )}
          <Chat />
        </div>
      </Button>
    </div>
  );
};
